import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Modal, Select, Button, Table, Checkbox, Input, Form } from 'antd'

import agentPayments from '@services/agentPayments'
import { alertPopup } from '@utils/popup'

@inject((store: any) => {
    const { popupStore, authStore } = store

    return {
        popupStore,
        authStore
    }
})
@observer
export default class PaymentPopup extends Component<any, any> {
    constructor(props) {
        super(props)
        this.state = {
            rawData: [],
            payments: [],
            updatedData: [],
            yearRange: [],
            currentYear: new Date().getFullYear(),
            selectedYear: new Date().getFullYear(),
            editTable: false,
            updateSaved: '',
            error: '',
            noCommissionsFound: '',
            summary: null
        }
    }

    componentDidMount(): void {
        if (this.props.agentInfo.id !== undefined) {
            this.fetchAllPayments()
        }
    }

    componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<any>, snapshot?: any): void {
        if (!prevProps.agentInfo.id && this.props.agentInfo.id) this.fetchAllPayments()
    }

    closePopup = () => {
        let close = true
        if (this.state.updateSaved === false) {
            close = confirm('השינויים לא נשמרו')
        }
        if (close === true) {
            this.fetchAllPayments()
            this.setState({ editTable: false, updateSaved: true, error: '' })
            this.props.popupStore.togglePopup(false)
        }
    }

    fetchAllPayments = () => {
        agentPayments
            .getPayments({ agentId: this.props.agentInfo.id, fromAdmin: true })
            .then(res => {
                if (res.data && res.data.payments) {
                    this.setState(
                        { rawData: this.prepareRawData(res.data.payments), error: '', noCommissionsFound: '' },
                        () => {
                            this.createYearRange(this.state.rawData)
                            this.filterPayments(this.state.rawData)
                        }
                    )
                }
            })
            .catch(err => {
                if (err.response.status !== 404) {
                    this.setState({ error: 'אירעה שגיאה בטעינת הנתונים' }, () => {
                        alertPopup({ type: 'error', title: this.state.error, body: '' })
                    })
                } else {
                    this.setState({ noCommissionsFound: 'לא נמצאו עמלות עבור סוכן זה' })
                }
            })
    }

    prepareRawData = array => {
        array.forEach(item => {
            item.monthName = this.toLiteralMonth(item.month)
            item.originalPayStatus = item.payed
        })
        return array
    }

    createYearRange = array => {
        let startAt = this.state.currentYear
        array.forEach(item => (startAt = item.year < startAt ? item.year : startAt))

        let yearRange = []
        for (let i = startAt; i <= this.state.currentYear; i++) {
            yearRange.push(i)
        }
        this.setState({ yearRange })
    }

    handleYearSelect = year => {
        this.setState({ selectedYear: year }, () => this.filterPayments(this.state.rawData))
    }

    setEditTable = () => {
        this.setState(prev => {
            return {
                editTable: !prev.editTable
            }
        }, this.forceUpdate())
    }

    toggleUpdateSaved = bool => {
        this.setState({ updateSaved: bool })
    }

    onTableUpdate = () => {
        this.setEditTable()
        this.sendUpdatedItems()
    }

    setNewStatus = updatedItem => {
        let rawData = [...this.state.rawData]
        rawData.forEach(row => {
            if (row.id === updatedItem.id) {
                row.payed = updatedItem.payed
            }
        })
        this.setState({ rawData })
    }

    sendUpdatedItems = () => {
        let updatedItems = this.state.rawData.filter(item => {
            if (item.payed !== item.originalPayStatus) {
                return { id: item.id, payed: item.payed }
            }
        })

        const update = { updatedItems: updatedItems }

        agentPayments
            .updatePayments(update)
            .then(res => {
                this.setState({ rawData: this.prepareRawData(res.data), error: '', noCommissionsFound: '' }, () => {
                    this.filterPayments(this.state.rawData)
                })
            })
            .catch(err => {
                this.setState({ error: 'אירעה שגיאה בשמירת השינויים', noCommissionsFound: '' }, () => {
                    alertPopup({ type: 'error', title: this.state.error, body: '' })
                })
            })
    }

    tryAgain = () => {
        this.fetchAllPayments()
    }
    formatNumber(num) {
        if (num === undefined || num === null) return ''
        let formatted = num.toFixed(2)
        if (formatted.includes('.') && formatted.endsWith('00')) formatted = parseFloat(formatted).toString()
        let str = formatted.toString()

        let parts = str.split('.')

        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')

        return parts.join('.')
    }

    filterPayments = array => {
        let payments = array.filter(item => item.year === this.state.selectedYear)
        payments.sort((a, b) => (a.month > b.month ? 1 : -1))
        const summary = array
            .filter(item => item.hide == 0 && item.payed == 0)
            .reduce((acc, item) => acc + item.amount, 0)
        this.setState({ payments, summary })
    }

    toLiteralMonth(number) {
        const months = {
            1: 'ינואר',
            2: 'פברואר',
            3: 'מרץ',
            4: 'אפריל',
            5: 'מאי',
            6: 'יוני',
            7: 'יולי',
            8: 'אוגוסט',
            9: 'ספטמבר',
            10: 'אוקטובר',
            11: 'נובמבר',
            12: 'דצמבר',
            13: 'סכום מצטבר'
        }
        return months[number]
    }

    sumTitle(title, color) {
        return <div style={{ color: color, fontSize: '15px', fontWeight: 'bold', direction: 'ltr' }}>{title}</div>
    }

    tableColumns = [
        {
            title: 'חודש',
            dataIndex: 'monthName',
            key: 'monthName',
            align: 'right'
        },
        {
            title: 'סכום',
            dataIndex: 'amount',
            key: 'amount',
            align: 'right',
            render: (bool, row) => {
                const color = bool > 0 ? 'green' : 'red'
                return <div style={{ direction: 'ltr' }}>{this.sumTitle(this.formatNumber(bool), color)}</div>
            }
        },
        {
            title: 'שולם',
            dataIndex: 'payed',
            key: 'payed',
            align: 'right',
            render: (bool, row) => {
                if (this.state.editTable) {
                    return this.checkItem(row)
                } else {
                    return bool ? this.payedItem : null
                }
            }
        },
        {
            title: '',
            dataIndex: 'hide',
            key: 'hide',
            align: 'right',
            width: '110px',
            render: (_, record) => (record.hide ? 'לא מוצג לסוכן' : '')
        }
    ]

    payedItem = (<div style={{ color: 'green', fontSize: '15px' }}> V </div>)
    checkItem = row => {
        return row.payed ? (
            <Checkbox defaultChecked onClick={() => this.setNewStatus({ ...row, payed: !row.payed })}></Checkbox>
        ) : (
            <Checkbox onClick={() => this.setNewStatus({ ...row, payed: !row.payed })}></Checkbox>
        )
    }

    render() {
        const {
            popupStore,
            agentInfo,
            authStore: { roles }
        } = this.props
        let fullName = `${agentInfo.first_name} ${agentInfo.last_name}`
        const color = this.state.summary > 0 ? 'green' : 'red'
        const summary = this.sumTitle(this.formatNumber(this.state.summary), color)
        const isLongName = fullName.length > 30

        return (
            <Modal
                title={`עמלות סוכן: ${fullName}`}
                visible={popupStore.popupType === 'paymentPopup'}
                onCancel={this.closePopup}
                footer={null}
                wrapClassName={isLongName ? 'payment-popup-long-name' : ''}
            >
                {isLongName && (
                    <style>{`
                        .payment-popup-long-name .ant-modal-header {
                            padding: 16px 17px 36px;
                        }
                    `}</style>
                )}
                <div style={{ position: 'relative' }}>
                    <div
                        style={
                            isLongName
                                ? ({
                                      ...styleSummary,
                                      top: '-55px',
                                      left: 'unset',
                                      right: '19px'
                                  } as React.CSSProperties)
                                : (styleSummary as React.CSSProperties)
                        }
                    >
                        <div style={{ marginLeft: '10px' }}>סכום מצטבר: </div>
                        {summary}
                    </div>
                    <div style={style1}>
                        <Select
                            style={{ width: '100%' }}
                            placeholder="בחר שנה"
                            value={this.state.selectedYear}
                            onChange={this.handleYearSelect}
                        >
                            {this.state.yearRange.map(year => (
                                <Select.Option key={year} value={year}>
                                    {year}
                                </Select.Option>
                            ))}
                        </Select>
                        {roles.includes('money') || roles.includes('admin')
                            ? !this.state.editTable && (
                                  <Button
                                      style={{ ...buttonStyle }}
                                      onClick={() => {
                                          this.setEditTable()
                                          this.toggleUpdateSaved(false)
                                      }}
                                  >
                                      עריכה
                                  </Button>
                              )
                            : ''}
                        {roles.includes('money') || roles.includes('admin')
                            ? this.state.editTable && (
                                  <Button
                                      style={{ ...buttonStyle }}
                                      onClick={() => {
                                          this.onTableUpdate()
                                          this.toggleUpdateSaved(true)
                                      }}
                                  >
                                      עדכן
                                  </Button>
                              )
                            : ''}
                    </div>
                    <Table pagination={false} dataSource={this.state.payments} columns={this.tableColumns} />
                    {this.state.error && (
                        <div style={style2}>
                            <Button onClick={this.tryAgain}>נסה/י שוב</Button>
                        </div>
                    )}
                </div>
            </Modal>
        )
    }
}

const style1 = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
}

const style2 = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    fontSize: '18px'
}

const styleSummary = {
    position: 'absolute',
    top: '-65px',
    left: '0',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center'
}

const buttonStyle = {
    height: '32px',
    marginBottom: '4px',
    marginRight: '5px'
}
